// billing-plugin/common/schemas/collections/invoices.js
import { z } from "zod";

const InvoiceSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    invoiceNumber: z.string().describe("Unique, sequential invoice number for display."),
    targetId: z.string().describe("The subscriptionId or userId this invoice is for."),
    
    status: z.enum(['draft', 'open', 'paid', 'void', 'uncollectible']).default('draft'),
    
    periodStart: z.coerce.date(),
    periodEnd: z.coerce.date(),
    issueDate: z.coerce.date(),
    dueDate: z.coerce.date(),
    
    chargeRecordIds: z.array(z.string()).describe("List of _ids from the chargeRecords collection included in this invoice."),
    
    subtotal: z.number().int(),
    taxes: z.number().int().default(0),
    total: z.number().int(),
    amountPaid: z.number().int().default(0),
    amountDue: z.number().int(),
    
    currency: z.string().length(3),
    pdfPath: z.string().optional().nullable().describe("Relative path to the generated PDF via UploadDownloadService."),
    createdAt: z.coerce.date().optional(),
});

export default InvoiceSchema;